export const volumes = [
  {
    n: 'Vol. I',
    title: 'The Beginning: Menarche & the Menstrual Cycle',
    desc: 'An exploration of the first period, cyclical health, menstrual patterns, and the foundations of hormonal wellbeing. Drawing on traditional knowledge and clinical herbalism to guide women from the very beginning of their cycle.',
  },
  {
    n: 'Vol. II',
    title: 'The Middle Years: Hormonal Health & Reproductive Wellbeing',
    desc: 'A comprehensive guide to hormonal balance, reproductive health, fertility, pregnancy, fibroids, PCOS, and the challenges women face in their prime years. Practical, plant-based, and grounded in 20+ years of specialist practice.',
  },
  {
    n: 'Vol. III',
    title: 'The Wisdom Years: Menopause and Beyond',
    desc: 'A deeply considered exploration of perimenopause, menopause, and the post-menopausal years, reframing this transition as a time of power, clarity, and renewal rather than loss.',
  },
]
